import React, { useRef } from 'react';
import { Help } from '@mui/icons-material';
import Popover from '@mui/material/Popover';
import { bindTrigger, bindPopover, usePopupState } from 'material-ui-popup-state/hooks';

interface Props {
    text: string,
}
const HelpIcon = ({ text }: Props): JSX.Element => {
    const popupState = usePopupState({ variant: 'popover', popupId: 'help-popover', disableAutoFocus: true });
    const [anchorEl, setAnchorEl] = React.useState<HTMLSpanElement | null>(null);
    const anchorRef = useRef(anchorEl);
    anchorRef.current = anchorEl;
    return (
        <span className="helpTopicButton" title={text}>
            <span
                ref={(ref) => setAnchorEl(ref)}
                {...bindTrigger(popupState)}
                onClick={() => {
                    popupState.open(anchorRef.current);
                }}
            >
                <Help fontSize="small" />
            </span>

            <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <p className="helpTopicPopup">
                    {text}
                </p>
            </Popover>
        </span>
    );
}

export default HelpIcon;